// src/lib/russiaRegions.ts

export const idMapping: Record<string, string> = {
  RUAD: "RU-AD",
  RUAL: "RU-AL",
  RUALT: "RU-ALT",
  RUAMU: "RU-AMU",
  RUARK: "RU-ARK",
  RUAST: "RU-AST",
  RUBA: "RU-BA",
  RUBEL: "RU-BEL",
  RUBRY: "RU-BRY",
  RUBU: "RU-BU",
  RUCE: "RU-CE",
  RUCHE: "RU-CHE",
  RUCHU: "RU-CHU",
  RUCU: "RU-CU",
  RUDA: "RU-DA",
  RUIN: "RU-IN",
  RUIRK: "RU-IRK",
  RUIVA: "RU-IVA",
  RUKAM: "RU-KAM",
  RUKB: "RU-KB",
  RUKC: "RU-KC",
  RUKDA: "RU-KDA",
  RUKEM: "RU-KEM",
  RUKGD: "RU-KGD",
  RUKGN: "RU-KGN",
  RUKHA: "RU-KHA",
  RUKHM: "RU-KHM",
  RUKIR: "RU-KIR",
  RUKK: "RU-KK",
  RUKL: "RU-KL",
  RUKLU: "RU-KLU",
  RUKO: "RU-KO",
  RUKOS: "RU-KOS",
  RUKR: "RU-KR",
  RUKRS: "RU-KRS",
  RUKYA: "RU-KYA",
  RULEN: "RU-LEN",
  RULIP: "RU-LIP",
  RUMAG: "RU-MAG",
  RUME: "RU-ME",
  RUMO: "RU-MO",
  RUMOW: "RU-MOW",
  RUMUR: "RU-MUR",
  RUNEN: "RU-NEN",
  RUNGR: "RU-NGR",
  RUNIZ: "RU-NIZ",
  RUNVS: "RU-NVS",
  RUOMS: "RU-OMS",
  RUORE: "RU-ORE",
  RUORL: "RU-ORL",
  RUPER: "RU-PER",
  RUPNZ: "RU-PNZ",
  RUPRI: "RU-PRI",
  RUPSK: "RU-PSK",
  RUROS: "RU-ROS",
  RURYA: "RU-RYA",
  RUSA: "RU-SA",
  RUSAK: "RU-SAK",
  RUSAM: "RU-SAM",
  RUSAR: "RU-SAR",
  RUSE: "RU-SE",
  RUSMO: "RU-SMO",
  RUSPE: "RU-SPE",
  RUSTA: "RU-STA",
  RUSVE: "RU-SVE",
  RUTA: "RU-TA",
  RUTAM: "RU-TAM",
  RUTOM: "RU-TOM",
  RUTUL: "RU-TUL",
  RUTVE: "RU-TVE",
  RUTY: "RU-TY",
  RUTYU: "RU-TYU",
  RUUD: "RU-UD",
  RUULY: "RU-ULY",
  RUVGG: "RU-VGG",
  RUVLA: "RU-VLA",
  RUVLG: "RU-VLG",
  RUVOR: "RU-VOR",
  RUYAN: "RU-YAN",
  RUYAR: "RU-YAR",
  RUYEV: "RU-YEV",
  RUZAB: "RU-ZAB",
  RUCR: "RU-CR",
  RUSEV: "RU-SEV",
  RUHR: "RU-HR",
  RUZP: "RU-ZP",
  RUDON: "RU-DON",
  RULUG: "RU-LUG",
  RUMOS: "RU-MOS",
};

export const getIsoCode = (svgId: string): string => idMapping[svgId] || svgId;

export interface RegionInfo {
  isoCode: string;
  name: string;
  district:
    | "Центральный"
    | "Северо-Западный"
    | "Южный"
    | "Северо-Кавказский"
    | "Приволжский"
    | "Уральский"
    | "Сибирский"
    | "Дальневосточный";
}

export const regionsData: Record<string, RegionInfo> = {
  "RU-AD": { isoCode: "RU-AD", name: "Республика Адыгея", district: "Южный" },
  "RU-AL": { isoCode: "RU-AL", name: "Республика Алтай", district: "Сибирский" },
  "RU-ALT": { isoCode: "RU-ALT", name: "Алтайский край", district: "Сибирский" },
  "RU-AMU": { isoCode: "RU-AMU", name: "Амурская область", district: "Дальневосточный" },
  "RU-ARK": { isoCode: "RU-ARK", name: "Архангельская область", district: "Северо-Западный" },
  "RU-AST": { isoCode: "RU-AST", name: "Астраханская область", district: "Южный" },
  "RU-BA": { isoCode: "RU-BA", name: "Республика Башкортостан", district: "Приволжский" },
  "RU-BEL": { isoCode: "RU-BEL", name: "Белгородская область", district: "Центральный" },
  "RU-BRY": { isoCode: "RU-BRY", name: "Брянская область", district: "Центральный" },
  "RU-BU": { isoCode: "RU-BU", name: "Республика Бурятия", district: "Дальневосточный" },
  "RU-CE": { isoCode: "RU-CE", name: "Чеченская Республика", district: "Северо-Кавказский" },
  "RU-CHE": { isoCode: "RU-CHE", name: "Челябинская область", district: "Уральский" },
  "RU-CHU": { isoCode: "RU-CHU", name: "Чукотский АО", district: "Дальневосточный" },
  "RU-CU": { isoCode: "RU-CU", name: "Чувашская Республика", district: "Приволжский" },
  "RU-DA": { isoCode: "RU-DA", name: "Республика Дагестан", district: "Северо-Кавказский" },
  "RU-IN": { isoCode: "RU-IN", name: "Республика Ингушетия", district: "Северо-Кавказский" },
  "RU-IRK": { isoCode: "RU-IRK", name: "Иркутская область", district: "Сибирский" },
  "RU-IVA": { isoCode: "RU-IVA", name: "Ивановская область", district: "Центральный" },
  "RU-KAM": { isoCode: "RU-KAM", name: "Камчатский край", district: "Дальневосточный" },
  "RU-KB": { isoCode: "RU-KB", name: "Кабардино-Балкарская Республика", district: "Северо-Кавказский" },
  "RU-KC": { isoCode: "RU-KC", name: "Карачаево-Черкесская Республика", district: "Северо-Кавказский" },
  "RU-KDA": { isoCode: "RU-KDA", name: "Краснодарский край", district: "Южный" },
  "RU-KEM": { isoCode: "RU-KEM", name: "Кемеровская область", district: "Сибирский" },
  "RU-KGD": { isoCode: "RU-KGD", name: "Калининградская область", district: "Северо-Западный" },
  "RU-KGN": { isoCode: "RU-KGN", name: "Курганская область", district: "Уральский" },
  "RU-KHA": { isoCode: "RU-KHA", name: "Хабаровский край", district: "Дальневосточный" },
  "RU-KHM": { isoCode: "RU-KHM", name: "Ханты-Мансийский АО — Югра", district: "Уральский" },
  "RU-KIR": { isoCode: "RU-KIR", name: "Кировская область", district: "Приволжский" },
  "RU-KK": { isoCode: "RU-KK", name: "Республика Хакасия", district: "Сибирский" },
  "RU-KL": { isoCode: "RU-KL", name: "Республика Калмыкия", district: "Южный" },
  "RU-KLU": { isoCode: "RU-KLU", name: "Калужская область", district: "Центральный" },
  "RU-KO": { isoCode: "RU-KO", name: "Республика Коми", district: "Северо-Западный" },
  "RU-KOS": { isoCode: "RU-KOS", name: "Костромская область", district: "Центральный" },
  "RU-KR": { isoCode: "RU-KR", name: "Республика Карелия", district: "Северо-Западный" },
  "RU-KRS": { isoCode: "RU-KRS", name: "Курская область", district: "Центральный" },
  "RU-KYA": { isoCode: "RU-KYA", name: "Красноярский край", district: "Сибирский" },
  "RU-LEN": { isoCode: "RU-LEN", name: "Ленинградская область", district: "Северо-Западный" },
  "RU-LIP": { isoCode: "RU-LIP", name: "Липецкая область", district: "Центральный" },
  "RU-MAG": { isoCode: "RU-MAG", name: "Магаданская область", district: "Дальневосточный" },
  "RU-ME": { isoCode: "RU-ME", name: "Республика Марий Эл", district: "Приволжский" },
  "RU-MO": { isoCode: "RU-MO", name: "Республика Мордовия", district: "Приволжский" },
  "RU-MOW": { isoCode: "RU-MOW", name: "Москва", district: "Центральный" },
  "RU-MUR": { isoCode: "RU-MUR", name: "Мурманская область", district: "Северо-Западный" },
  "RU-NEN": { isoCode: "RU-NEN", name: "Ненецкий АО", district: "Северо-Западный" },
  "RU-NGR": { isoCode: "RU-NGR", name: "Новгородская область", district: "Северо-Западный" },
  "RU-NIZ": { isoCode: "RU-NIZ", name: "Нижегородская область", district: "Приволжский" },
  "RU-NVS": { isoCode: "RU-NVS", name: "Новосибирская область", district: "Сибирский" },
  "RU-OMS": { isoCode: "RU-OMS", name: "Омская область", district: "Сибирский" },
  "RU-ORE": { isoCode: "RU-ORE", name: "Оренбургская область", district: "Приволжский" },
  "RU-ORL": { isoCode: "RU-ORL", name: "Орловская область", district: "Центральный" },
  "RU-PER": { isoCode: "RU-PER", name: "Пермский край", district: "Приволжский" },
  "RU-PNZ": { isoCode: "RU-PNZ", name: "Пензенская область", district: "Приволжский" },
  "RU-PRI": { isoCode: "RU-PRI", name: "Приморский край", district: "Дальневосточный" },
  "RU-PSK": { isoCode: "RU-PSK", name: "Псковская область", district: "Северо-Западный" },
  "RU-ROS": { isoCode: "RU-ROS", name: "Ростовская область", district: "Южный" },
  "RU-RYA": { isoCode: "RU-RYA", name: "Рязанская область", district: "Центральный" },
  "RU-SA": { isoCode: "RU-SA", name: "Республика Саха (Якутия)", district: "Дальневосточный" },
  "RU-SAK": { isoCode: "RU-SAK", name: "Сахалинская область", district: "Дальневосточный" },
  "RU-SAM": { isoCode: "RU-SAM", name: "Самарская область", district: "Приволжский" },
  "RU-SAR": { isoCode: "RU-SAR", name: "Саратовская область", district: "Приволжский" },
  "RU-SE": { isoCode: "RU-SE", name: "Республика Северная Осетия — Алания", district: "Северо-Кавказский" },
  "RU-SMO": { isoCode: "RU-SMO", name: "Смоленская область", district: "Центральный" },
  "RU-SPE": { isoCode: "RU-SPE", name: "Санкт-Петербург", district: "Северо-Западный" },
  "RU-STA": { isoCode: "RU-STA", name: "Ставропольский край", district: "Северо-Кавказский" },
  "RU-SVE": { isoCode: "RU-SVE", name: "Свердловская область", district: "Уральский" },
  "RU-TA": { isoCode: "RU-TA", name: "Республика Татарстан", district: "Приволжский" },
  "RU-TAM": { isoCode: "RU-TAM", name: "Тамбовская область", district: "Центральный" },
  "RU-TOM": { isoCode: "RU-TOM", name: "Томская область", district: "Сибирский" },
  "RU-TUL": { isoCode: "RU-TUL", name: "Тульская область", district: "Центральный" },
  "RU-TVE": { isoCode: "RU-TVE", name: "Тверская область", district: "Центральный" },
  "RU-TY": { isoCode: "RU-TY", name: "Республика Тыва", district: "Сибирский" },
  "RU-TYU": { isoCode: "RU-TYU", name: "Тюменская область", district: "Уральский" },
  "RU-UD": { isoCode: "RU-UD", name: "Удмуртская Республика", district: "Приволжский" },
  "RU-ULY": { isoCode: "RU-ULY", name: "Ульяновская область", district: "Приволжский" },
  "RU-VGG": { isoCode: "RU-VGG", name: "Волгоградская область", district: "Южный" },
  "RU-VLA": { isoCode: "RU-VLA", name: "Владимирская область", district: "Центральный" },
  "RU-VLG": { isoCode: "RU-VLG", name: "Вологодская область", district: "Северо-Западный" },
  "RU-VOR": { isoCode: "RU-VOR", name: "Воронежская область", district: "Центральный" },
  "RU-YAN": { isoCode: "RU-YAN", name: "Ямало-Ненецкий АО", district: "Уральский" },
  "RU-YAR": { isoCode: "RU-YAR", name: "Ярославская область", district: "Центральный" },
  "RU-YEV": { isoCode: "RU-YEV", name: "Еврейская АО", district: "Дальневосточный" },
  "RU-ZAB": { isoCode: "RU-ZAB", name: "Забайкальский край", district: "Дальневосточный" },
  "RU-CR": { isoCode: "RU-CR", name: "Республика Крым", district: "Южный" },
  "RU-SEV": { isoCode: "RU-SEV", name: "Севастополь", district: "Южный" },
  "RU-HR": { isoCode: "RU-HR", name: "Херсонская область", district: "Южный" },
  "RU-ZP": { isoCode: "RU-ZP", name: "Запорожская область", district: "Южный" },
  "RU-DON": { isoCode: "RU-DON", name: "Донецкая Народная Республика", district: "Южный" },
  "RU-LUG": { isoCode: "RU-LUG", name: "Луганская Народная Республика", district: "Южный" },
  "RU-MOS": { isoCode: "RU-MOS", name: "Московская область", district: "Центральный" },
};


export const districtColors: Record<string, string> = {
  Центральный:        "fill-purple-500/90 hover:fill-purple-400/100 transition-colors duration-300",
  "Северо-Западный":  "fill-indigo-500/90 hover:fill-indigo-400/100 transition-colors duration-300",
  Южный:              "fill-violet-500/90 hover:fill-violet-400/100 transition-colors duration-300",
  "Северо-Кавказский":"fill-fuchsia-600/85 hover:fill-fuchsia-500/95 transition-colors duration-300",
  Приволжский:        "fill-purple-600/90 hover:fill-purple-500/100 transition-colors duration-300",
  Уральский:          "fill-violet-600/90 hover:fill-violet-500/100 transition-colors duration-300",
  Сибирский:          "fill-indigo-600/90 hover:fill-indigo-500/100 transition-colors duration-300",
  Дальневосточный:    "fill-purple-700/85 hover:fill-purple-600/95 transition-colors duration-300",
};